import { FC } from "react";
import { Field, FieldRenderProps } from "react-final-form";

import { Input, SpacingToken } from "@livechat/design-system-react-components";

import { FormFieldNoMargin } from "components/design-system-adapters/styled/form-field";
import { Divider } from "components/divider/Divider";
import Flex from "components/layout/Flex";
import { FormBlockType, IFormBlockInput } from "store/entities/contact-forms/interfaces";
import { withVar } from "themes/helpers";

import { RequiredErrorField } from "./parts/RequiredErrorField";

interface IProps {
  name: string;
  blockType: Extract<FormBlockType, "input" | "name">;
}

export const InputBlock: FC<IProps> = ({ name, blockType }) => {
  return <Field name={name} component={InputBlockInput} blockType={blockType} />;
};

const InputBlockInput: FC<FieldRenderProps<IFormBlockInput>> = ({ input, blockType }) => {
  const isRequired = input.value.required;

  return (
    <Flex column gap={withVar(SpacingToken.Spacing4)}>
      <Field name={`${input.name}.value`}>
        {({ input, meta }) => (
          <FormFieldNoMargin labelText={`${blockType === "name" ? "Name" : "Text input"} label`} error={meta.error}>
            <Input {...input} error={meta.error} data-testid={`${blockType}-input-label`} />
          </FormFieldNoMargin>
        )}
      </Field>
      {isRequired && (
        <div>
          <Divider />
          <Field name={`${input.name}.requiredError`} render={RequiredErrorField} blockType="input" />
        </div>
      )}
    </Flex>
  );
};
